import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function SugiHistoryManage() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    let location = useLocation();

    let MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);
    const [cancelListData, setCancelListData] = useState([]);

    // 표에 뿌려줄 tableBodyData
    const [combineData, setCombineData] = useState([]);
    const [combineList, setCombineList] = useState([]);
    const [cancelCombineData, setCancelCombineData] = useState([]);
    const [cancelCombineList, setCancelCombineList] = useState([]);

    const [reload, setReload] = useState(false);
    const [activeTab, setActiveTab] = useState("수기결제");
    const [listState, setListState] = useState(false);

    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    const productList = ["노트북", "기능성 속옷", "중고명품", "의료기", "수산물", "공기청정기", "홍삼", "가전제품"];

    useEffect(() => {
        dispatch(change_Current_Location("수기결제처리내역"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "수기결제처리내역",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    useEffect(() => {
        if (location?.state) {
            setActiveTab(location?.state?.tab ?? "수기결제")
        }
    }, [location])

    // 날짜 선택
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload((e) => !e);
    };

    useEffect(() => {
        ListData();
        CancelListData();
    }, [reload]);

    // ================================
    // 수기결제 리스트 불러오기
    // ================================
    const ListData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/sugi", {
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                // 예시로 상품 선택/직접입력을 위한 필드 추가
                const withProducts = tmp?.data?.map((item) => ({
                    ...item,
                    selectedProduct: "노트북", // 기본값
                    GoodsName: "",
                }));
                setListData(withProducts ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // ================================
    // 수기결제취소 리스트 불러오기
    // ================================
    const CancelListData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/sugi/cancel/list",
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                const withProducts = tmp?.data?.map((item) => ({
                    ...item,
                    selectedProduct: "티셔츠",
                    GoodsName: "",
                }));
                setCancelListData(withProducts ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // ================================
    // select: 상품명 목록
    // ================================
    const handleSelectChange = (e, rowId) => {
        const newValue = e.target.value;
        const newList = [...listData];
        const index = newList.findIndex((item) => item.id === rowId);
        if (index > -1) {
            newList[index].selectedProduct = newValue;
            // 직업입력이 아니면 GoodsName도 덮어씀
            if (newValue !== "직접입력") {
                newList[index].GoodsName = newValue;
            }
        }
        setListData(newList);
    };

    // ================================
    // input: 직접입력 (상품명) 
    // ================================
    const handleGoodsNameChange = (e, rowId) => {
        const newValue = e.target.value;
        console.log(newValue, rowId)
        // IME 오류 방지용 => composition?
        // (필요시 composition approach 추가)
        console.log(listData)
        const newList = [...listData];
        const index = newList.findIndex((item) => item.id === rowId);
        if (index > -1) {
            newList[index].GoodsName = newValue;
        }
        setListData(newList);
    };

    // ================================
    // 승인
    // ================================
    const onSubmitData = async (found) => {
        if (!window.confirm("수기결제 승인요청을 승인하시겠습니까?")) return;
        try {
            let metadataObj = {};
            let productObj = [];

            try {
                metadataObj = JSON.parse(found?.metadata || "{}");
                productObj = JSON.parse(found?.product || "[]");
            } catch (e) {
                console.error("파싱 오류:", e);
            }

            const rawCardNumber = (found?.req_card_number ?? "").replace(/\D/g, "");
            const amtVal = String(found?.req_amount ?? "").replace(/\D/g, "");

            // 최종 상품명
            const finalGoodsName =
                found.selectedProduct === "직접입력"
                    ? found.GoodsName
                    : found.selectedProduct;

            const body = {
                id: found.id,
                mid: found?.co_nm || "",
                payerName: found?.req_payer_name || "",
                payerEmail: found?.req_payer_email || "",
                payerTel: (found?.req_payer_tel ?? "").replace(/\D/g, ""),
                cardNumber: rawCardNumber,
                cardExpiry:
                    found?.req_card_expiry?.slice(0, 2) +
                    found?.req_card_expiry?.slice(2, 4),
                cardCvv: found?.req_card_cvv || "",
                installment: found?.req_installment || "00",
                products: [
                    {
                        prodId: "",
                        name: finalGoodsName,
                        qty: 1,
                        price: amtVal,
                        desc: "수기결제",
                    },
                ],
                metadata: {
                    cardAuth: "true",
                    authPw: metadataObj?.authPw || "",
                    authDob: metadataObj?.authDob || "",
                },
                amount: amtVal,
            };

            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/confirm",
                body,
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp);
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 승인 요청 실패" });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "승인 요청 중 오류가 발생했습니다." });
        }
    };

    // ================================
    // 거절
    // ================================
    const onDeleteData = async (id) => {
        if (!window.confirm("수기결제 승인요청을 거절하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/reject",
                { id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp);
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ================================
    // 취소승인
    // ================================
    const onCancelSubmitData = async (id) => {
        if (!window.confirm("수기결제 취소승인요청을 승인하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/cancel/confirm",
                { id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp);
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 취소승인 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ================================
    // 취소거절
    // ================================
    const onCancelDeleteData = async (id) => {
        if (!window.confirm("수기결제 취소승인요청을 거절하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/cancel/reject",
                { id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            console.log(tmp);
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ================================
    // 테이블 헤더
    // ================================
    const tableHeaderData = [
        { no: 1, text: "시간", width: "70px", textAlign: "center" },
        { no: 2, text: "상태", width: "80px", textAlign: "center" },
        { no: 3, text: "상품명", width: "150px", textAlign: "center" },
        { no: 4, text: "에이전트", width: "150px", textAlign: "center" },
        { no: 5, text: "금액", width: "90px", textAlign: "center" },
        { no: 8, text: "가맹점", width: "150px", textAlign: "center" },
        { no: 9, text: "비고", width: "150px", textAlign: "center" },
    ];

    const tableHeaderData1 = [
        { no: 1, text: "시간", width: "70px", textAlign: "center" },
        { no: 2, text: "상태", width: "80px", textAlign: "center" },
        { no: 3, text: "가맹점", width: "150px", textAlign: "center" },
        { no: 4, text: "금액", width: "90px", textAlign: "center" },
        { no: 5, text: "승인번호", width: "100px", textAlign: "center" },
        { no: 7, text: "비고", width: "150px", textAlign: "center" },
    ];

    // ================================
    // "수기결제" 탭 테이블
    // ================================
    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            setCombineList(listData);

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i];
                let metadataObj = {};
                let productObj = [];
    
                try {
                    metadataObj = JSON.parse(data?.metadata || "{}");
                    productObj = JSON.parse(data?.product || "[]");
                } catch (e) {
                    console.error("파싱 오류:", e);
                }
                
                let rowData = [
                    {
                        no: 1,
                        text: getDisplayTime(data.reg_date),
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 2,
                        text: data.status,
                        width: "80px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: productObj[0]?.name??"",    // input or div
                        width: "150px",
                        textAlign: "left",
                    },
                    {
                        no: 4,
                        text: data.name, // 에이전트명(예시)
                        width: "150px",
                        textAlign: "left",
                    },
                    {
                        no: 5,
                        text: changeNum(data.req_amount),
                        width: "90px",
                        textAlign: "right",
                    },
                    {
                        no: 8,
                        text: data.co_nm,
                        width: "150px",
                        textAlign: "left",
                    },
                    {
                        no: 9,
                        text: data.desc,
                        width: "150px",
                        textAlign: "left",
                    },
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
            setListState((e) => !e);
            setCombineData(tableBodyData);
        }
    }, [listData]);

    // ================================
    // "수기결제취소" 탭 테이블
    // ================================
    useEffect(() => {
        let tableBodyData = [];
        if (cancelListData) {
            setCancelCombineList(cancelListData);

            for (let i = 0; i < cancelListData.length; i++) {
                let data = cancelListData[i];
                let rowData = [
                    {
                        no: 1,
                        text: getDisplayTime(data.created_at),
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 2,
                        text: data.status,
                        width: "80px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: data.co_nm,
                        width: "150px",
                        textAlign: "left",
                    },
                    {
                        no: 4,
                        text: changeNum(data.amt),
                        width: "90px",
                        textAlign: "right",
                    },
                    {
                        no: 5,
                        text: data.approval_id,
                        width: "100px",
                        textAlign: "center",
                    },
                    {
                        no: 7,
                        text: data.desc,
                        width: "150px",
                        textAlign: "left",
                    },
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
            setListState((e) => !e);
            setCancelCombineData(tableBodyData);
        }
    }, [cancelListData]);

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    const tabList = ["수기결제", "수기결제취소"];

    // 경과 시간 표시
    const getDisplayTime = (regDate) => {
        const now = new Date();
        const dateObj = new Date(regDate);
        const kstDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000);
        const diffMs = now - kstDate;

        const diffMinutes = Math.floor(diffMs / 1000 / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMinutes < 60) return `${diffMinutes}분`;
        if (diffHours < 24) return `${diffHours}시간`;
        return `${diffDays}일`;
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
            >
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                        borderBottom: "1px solid #E5E5E5",
                        backgroundColor: "#fff",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom:
                                        activeTab === tab
                                            ? "3px solid #3182F6"
                                            : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                {activeTab === "수기결제" ? (
                    <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                        <div style={{ width: "100%", maxWidth: "850px" }}>
                            <List
                                tableHeaderData={tableHeaderData}
                                tableBodyData={combineList ?? []}
                                filter_tableBodyData={combineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                listType={true}
                                listState={listState}
                                nonePage={false}
                            />
                        </div>
                    </div>
                ) : (
                    <div style={{ width: "100%", maxWidth: "650px" }}>
                        <List
                            tableHeaderData={tableHeaderData1}
                            tableBodyData={cancelCombineList ?? []}
                            filter_tableBodyData={cancelCombineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            nonePage={false}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default SugiHistoryManage